'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'party-horn';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e31b';
var svgPathData = ['M17 474.4c-4.6 12.4 8.3 25.3 20.6 20.6l91.7-34.4-77.9-77.9-34.4 91.7zM57.6 366.3l88.2 88.2 76.6-28.7-136.1-136.1-28.7 76.6zm34.8-92.9c.4 .3 .9 .6 1.2 1l144 144c.4 .4 .7 .8 1 1.3l55.2-20.7c10.5-3.9 13.7-18.4 5.7-26.3L139.4 212.5c-8-8-22.4-4.8-26.3 5.7L92.4 273.3z', 'M48 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM17 474.4l34.4-91.7 77.9 77.9-91.7 34.4c-12.4 4.6-25.3-8.3-20.6-20.6zm128.7-19.9l-88.2-88.2 28.7-76.6 136.1 136.1-76.6 28.7zM93.7 274.3c-.4-.4-.8-.7-1.2-1l20.7-55.1c3.9-10.5 18.4-13.7 26.3-5.7L299.6 372.6c8 8 4.8 22.4-5.7 26.3l-55.2 20.7c-.3-.4-.6-.9-1-1.3l-144-144zm57.1-73.2c-16.2-16.2-44.6-10-52.6 11.4L2 468.8c-9.5 25.2 16 50.7 41.2 41.2l256.2-96.1c21.4-8 27.6-36.4 11.4-52.6L150.7 201.2zM480 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM450.7 72.7l19-19c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-19 19C432.5 68.2 423.3 72 413.6 72l-11 0c-30.4 0-51.8 29.7-42.2 58.5 6.1 18.4-7.6 37.5-27 37.5l-11 0c-13.9 0-27.2 5.5-37.1 15.3l-19 19c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l19-19c6.8-6.8 16.1-10.7 25.7-10.7l11 0c30.4 0 51.8-29.7 42.2-58.5-6.1-18.4 7.6-37.5 27-37.5l11 0c13.9 0 27.2-5.5 37.1-15.3zM224 24c-4.4 0-8 3.6-8 8l0 24.2c0 23.3-9.3 45.7-25.8 62.2l-19.9 19.9c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l19.9-19.9C221 110.3 232 83.8 232 56.2L232 32c0-4.4-3.6-8-8-8zM480 280l-24.2 0c-27.6 0-54 11-73.5 30.5l-19.9 19.9c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l19.9-19.9C410 305.3 432.4 296 455.8 296l24.2 0c4.4 0 8-3.6 8-8s-3.6-8-8-8z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPartyHorn = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;